import { render, staticRenderFns } from "./Blip.vue?vue&type=template&id=2dfa38ed&scoped=true&"
import script from "./Blip.vue?vue&type=script&lang=ts&"
export * from "./Blip.vue?vue&type=script&lang=ts&"
import style0 from "./Blip.vue?vue&type=style&index=0&id=2dfa38ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa38ed",
  null
  
)

export default component.exports